/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Comment_FailedInputs */

const en_toast_comment_failed = /** @type {(inputs: Toast_Comment_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your comment could not be posted.`)
};

const de_toast_comment_failed = /** @type {(inputs: Toast_Comment_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Kommentar konnte nicht gesendet werden.`)
};

/**
* | output |
* | --- |
* | "Your comment could not be posted." |
*
* @param {Toast_Comment_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_comment_failed = /** @type {((inputs?: Toast_Comment_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Comment_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_comment_failed(inputs)
	return en_toast_comment_failed(inputs)
});